import Layout from './AuthLayout.vue'
import { RouteRecordRaw } from 'vue-router'
import views from './views'

export default <Array<RouteRecordRaw>>[
  {
    path: '/auth',
    meta: { requireAuth: false },
    component: Layout,
    children: views
  }
]
